export function fvMovieLoop() {
  const video = document.getElementById('fvMovie');

  video.oncanplaythrough = () => {
    video.style.opacity = 1; // フェードイン
  };

  // 動画の長さが取得できたら
  video.onloadedmetadata = () => {
    const fadeOutTime = .5; // フェードアウトを開始する秒数
    const fadeOutStart = video.duration - fadeOutTime;

    // 動画の再生位置がフェードアウト開始時間に達したらフェードアウトを開始
    video.ontimeupdate = () => {
      if (video.currentTime >= fadeOutStart) {
        video.style.opacity = 0; // フェードアウト
      }
    };
  };

  video.onended = () => {
    video.currentTime = 0; // 動画を最初に戻す
    video.play();
  };
}